module.exports = __webpack_public_path__ + "img/claude-terminal.f891e5c3.png";